import { useMemo } from 'react';

/** 满分 100、共 5 颗星，每颗 20 分；当前段 ≥10 为半星，≥20 为整星 */
const POINTS_PER_STAR = 20;

export type FJViralStarKind = 'full' | 'half' | 'empty';

export function viralScoreToStarKinds(score: number): FJViralStarKind[] {
    const clamped = Math.max(0, Math.min(100, score));
    let remaining = clamped;
    const out: FJViralStarKind[] = [];

    for (let i = 0; i < 5; i++) {
        if (remaining >= POINTS_PER_STAR) {
            out.push('full');
            remaining -= POINTS_PER_STAR;
        } else if (remaining >= POINTS_PER_STAR / 2) {
            out.push('half');
            remaining = 0;
        } else {
            out.push('empty');
        }
    }

    return out;
}

/** 病毒分 → 五星展示（`full` / `half` / `empty`），随 `score` 记忆化 */
export function useViralScoreStars(score: number): FJViralStarKind[] {
    return useMemo(() => viralScoreToStarKinds(score), [score]);
}
